import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { CoreDialogService } from 'src/app/core/dialogs/core-dialog.service';
import { ViewComponent } from 'src/app/core/view/view.component';
import { ViewsService } from 'src/app/core/view/views.service';
import { OrganizationsService } from '../../organizations.service';
import { ContactsService } from '../organizations-contacts-detail/contacts.service';
import { OrganizationsContactsDetailComponent } from '../organizations-contacts-detail/organizations-contacts-detail.component';

@Component({
  selector: 'app-organizations-contacts-view',
  templateUrl: './organizations-contacts-view.component.html',
  styleUrls: ['./organizations-contacts-view.component.scss']
})
export class OrganizationsContactsViewComponent implements OnInit {
  @ViewChild("view") public viewComponent: ViewComponent;
  public organization: any = {};
  public contacts: any[];
  public totalRecords: any;
  public loading = false;
  public lastGridEvent: any;

  constructor(
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private organizationsService: OrganizationsService,
    private messageService: MessageService,
    private contactsService: ContactsService,
    private coreDialogService: CoreDialogService,
    private viewsService: ViewsService,
    private router: Router
  ) { }

  ngOnInit(): void {
  }
  loadData($event) {
    this.route.parent.params.subscribe(params => {
      this.loadDataOrganization(params['id']);
      this.lastGridEvent = $event;
      this.loading = true;
      var contactParams = {
        _page: $event.first,
        _pageSize: $event.rows,
        _sortBy: $event.sortField ? $event.sortField : "",
        _sortDirection: $event.sortOrder > 0 ? "asc" : "desc",
        organization_id: params['id']
      }
      this.contactsService.all(contactParams).subscribe(
        data => {
          this.totalRecords = data.totalRows;
          this.contacts = data.rows;
          this.loading = false;
        },
        error => {
          this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
          this.loading = false;
        }
      )
    });
  }
  loadDataOrganization(id: number) {
    this.organizationsService.get(id).subscribe(
      data => {
        this.organization = data;
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
      }
    )
  }
  view(contact) {
    this.router.navigate(["/contacts/" + (this.organization.id + "/") + (contact ? contact.id : 0)]);
    /*
    const ref = this.dialogService.open(OrganizationsContactsDetailComponent,{
      data: {
        id: this.organization.id,
        contactId: contact?contact.id:0
      },
      //header: contact? "Detalles del contacto":"Nuevo contacto",
      width: '70%',
    });
    ref.onClose.subscribe((data:any) =>{
      if (typeof (this.viewComponent) !== "undefined") this.viewsService.changeView(this.viewComponent.code);
      this.loadData(this.lastGridEvent);
    });
    */
  }
  delete(contact) {
    this.coreDialogService.confirm({
      message: "¿Quieres borrar el contacto " + contact.name + "?",
      header: "Confirmación de borrado",
      icon: "pi pi-info-circle",
      accept: () => {
        this.contactsService.delete(contact.id).subscribe(
          data => {
            this.messageService.add({ closable: false, severity: 'success', detail: "Borrado correctamente" });
            this.loadData(this.lastGridEvent);
          },
          error => {
            this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
          }
        )
      },
      reject: () => {

      }
    })
  }
}
